import { createFileRoute, Link } from "@tanstack/react-router";
import { Award } from "lucide-react";
import { AppShell } from "@/components/AppShell";
import { PageHeader } from "@/components/PageHeader";
import { AchievementsGrid } from "@/components/AchievementsGrid";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/conquistas")({
  head: () => ({
    meta: [
      { title: "Minhas conquistas — Viny Club" },
      {
        name: "description",
        content: "Acompanhe suas conquistas no Viny Club: badges desbloqueadas e próximas metas.",
      },
    ],
  }),
  component: ConquistasPage,
});

function ConquistasPage() {
  const { user, profile, loading } = useCurrentUser();

  return (
    <AppShell>
      <PageHeader
        eyebrow="Conta"
        title="Minhas conquistas"
        subtitle="Veja tudo que já desbloqueou e o que ainda falta conquistar."
      />


      <div className="mx-auto w-full max-w-[1400px] px-4 pb-20 lg:px-5">
        {loading ? (
          <div className="mt-8 h-48 animate-pulse rounded-2xl border border-[color:var(--hairline)] bg-surface/40" />
        ) : user ? (
          <AchievementsGrid userId={user.id} />
        ) : (
          <div className="mt-8 rounded-2xl border border-[color:var(--hairline)] bg-surface/40 p-8 text-center text-sm text-muted-foreground">
            <p>Entre para ver suas conquistas.</p>
            <Link
              to="/auth"
              className="mt-4 inline-flex rounded-full bg-foreground px-5 py-2 text-sm font-semibold text-background"
            >
              Entrar
            </Link>
          </div>
        )}
        {profile && (
          <div className="mt-6 text-center">
            <Link
              to="/profile/$username"
              params={{ username: profile.username }}
              className="text-xs uppercase tracking-[0.18em] text-muted-foreground hover:text-foreground"
            >
              Ver perfil completo
            </Link>
          </div>
        )}
      </div>
    </AppShell>
  );
}
